import type { FaireProductEntity } from "../../entity_types/product";

export const p_rxvve8b7tb: FaireProductEntity = {
  token: "p_rxvve8b7tb",
  type: "product",
  name: "Our Bucket List Adventures: A Guided Journal for Couples",
  brandToken: "b_x27fkb4h4a",
  brandName: "Paige Tate & Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/eaf54583736aa1fd6eafda5885a158619d5dbf3fb2c9307c2b14bd5c7a756e3d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/977d73eeb4c5610629579f1fd59fa7f9f58489bdcb14ef2004778b2b42fda78a.jpeg",
    "https://cdn.faire.com/fastly/a93f23499a0d5b2275cff36fcceed73d8c023215e2838b268a73aebfa0e4c209.jpeg",
    "https://cdn.faire.com/fastly/fe6f73f3276c92dd333387f891ae81f2c94db91c8f8baea50928af7014a92e83.jpeg",
    "https://cdn.faire.com/fastly/b27ccb7ba5d8b9c3fa20991298824739b3c43d5f4dc4aba091619daaac1430e4.jpeg",
    "https://cdn.faire.com/fastly/d739c031c9ef7c2696d467c92bd31a706fc69f6bfd28174676589785fab5a6f8.jpeg",
    "https://cdn.faire.com/fastly/44369e4efded72570a3423364ba56e794b3acd698ae027214b132b7904622bf4.jpeg",
  ],
  priceDollars: 12.27,
  description:
    "The perfect adventure book for couples, this beautifully-designed bucket list journal will let you keep track of you and your partner's goals and then record all the memories once you make them happen.\n\nOur Bucket List Adventures by bestselling author and artist, Korie Herold, is an heirloom-quality keepsake for couples with guided prompts, journaling space, and elegant design details. It’s a meaningful way to track life’s shared adventures.\n\n• Space to plan & reflect on bucket list goals—big and small\n• Elegant cloth cover with gold foil and hand-drawn illustrations\n• Lay-flat binding and archival-quality pages for lasting memories\n• Includes gold foil stickers to mark completed adventures\n• Ideal for wedding gifts, anniversaries, or milestone gifts\n\nCategories: journals and notebooks, Faire Market 2026, couples journal, couples date night, bucketlist, bucket list book, travel journals, wedding gifts, vintage, newlywed book, mothers day",
  tags: [],
  msrpDollars: 27.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:49.477Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
